/**
 * Paths that must never bounce a lost session to /login.
 * Guest menus, auth screens, and the marketing landing stay where they are.
 */
export function isPublicSessionPath(pathname: string): boolean {
  return (
    pathname === '/' ||
    pathname.startsWith('/login') ||
    pathname.startsWith('/register') ||
    pathname.startsWith('/m/') ||
    pathname.startsWith('/book/') ||
    pathname.startsWith('/t/') ||
    (import.meta.env.DEV && pathname.startsWith('/__dev'))
  );
}

/** Maps scroll progress 0–1 onto a pinned chapter index. */
export function chapterIndex(progress: number, count: number): number {
  if (count <= 1) return 0;
  const clamped = Math.min(1, Math.max(0, progress));
  return Math.min(count - 1, Math.floor(clamped * count));
}
